// Radio Group
// ===========

import DOM from '../Library/DOM';
import Locker from '../Library/Locker';

class RadioGroup extends EventTarget {
    constructor(container, enableDeselect = false, unlock = false) {
        super();
        this.enableDeselect = enableDeselect;
        this.container = DOM.getElement(container);
        this.radios = this.container.querySelectorAll('input[type=radio]');
        this.radios.forEach((radio) => {
            if (radio.checked) this.selectedValue = radio.value;
            radio.dataset.disabled = (radio.disabled) ? '1' : '0';
            radio.addEventListener('click', (e) => { this.onRadioClick(e); });
        });
        if (unlock) this.unlock();
    }

    disableExceptValue(value) {
        this.radios.forEach((radio) => {
            radio.disabled = (radio.value !== value);
        });
    }

    set disabled(value) {
        this.radios.forEach((radio) => {
            radio.disabled = value;
        });
    }

    lock() {
        this.radios.forEach((element) => {
            Locker.lock(element);
        });
    }

    onRadioClick(e) {
        if (e.currentTarget.value === this.selectedValue) {
            if (this.enableDeselect) {
                e.currentTarget.checked = false;
                this.setSelectedValue('');
            }
        } else {
            this.setSelectedValue(e.currentTarget.value);
        }
    }

    reset() {
        this.radios.forEach((radio) => {
            radio.disabled = (radio.dataset.disabled === '1');
        });
    }

    setSelectedValue(value) {
        if (this.selectedValue !== value) {
            this.selectedValue = value;
            this.dispatchEvent(new Event('change'));
        }
    }

    unlock() {
        this.radios.forEach((element) => {
            Locker.unlock(element);
        });
    }

    get value() {
        return this.selectedValue;
    }

    set value(value) {
        let found = false;
        this.radios.forEach((radio) => {
            radio.checked = (radio.value === value);
            if (radio.checked) found = true;
        });
        this.selectedValue = (found) ? value : '';
    }
}

export default RadioGroup;
